import React, { useEffect, useCallback, useState } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import { Txt, EquipmentsSelectInput, CheckBox } from '../../../../../../components'
import { useTheme } from '../../../../../../theming/ThemeProvider'
import useStyles from './useStyles'
import SelectInput from '../../../../../../components/SelectInput'
import InputFormik from '../../../../../../components/InputFormik'
import { isTheSelectMenuClicked } from '../../../../../../tools/general'

const TractorForm = (props) => {
  const { recurringTractor, day, setCurrentDay, daysToShow, onSave } = props

  const [tractor, setTractor] = useState({})
  const { theme } = useTheme()
  const styles = useStyles(theme)

  useEffect(() => {
    setTractor(day?.name ? {
      available: recurringTractor[`tractors_available_${day?.name}`],
      equipmentType: recurringTractor[`equipment_type_id_${day?.name}`],
      teams: recurringTractor[`teams_${day?.name}`]
    } : {})
  }, [recurringTractor, day])

  const onChangeValue = useCallback((name, value) => {
    setTractor(state => ({
      ...state,
      [name]: value
    }))
  }, [])

  const onClickOutside = useCallback((event) => {
    const form = document.querySelector(`[data-testid="recurringTractorsModalTractorsForm${day?.label}"]`)
    const addButton = document.querySelector('[data-testid="recurringTractorsModalAddTractorButton"]')
    if (form?.contains(event.target) || isTheSelectMenuClicked(event)) {
      event.stopPropagation()
    } else {
      onSave(tractor, addButton?.contains(event.target))
    }
  }, [day, onSave, tractor])

  useEffect(() => {
    window.addEventListener('click', onClickOutside)
    return () => {
      window.removeEventListener('click', onClickOutside)
    }
  }, [onClickOutside])

  return (
    <View testID={`recurringTractorsModalTractorsForm${day?.label}`}>
      <View style={styles.inputsContainer}>
        <View style={styles.dayOfWeek}>
          <SelectInput
            name='day'
            selected={day}
            onChange={(_, value) => setCurrentDay(value)}
            icon='Calendar'
            placeholder='Day of Week'
            keyProp='name'
            nameProp='label'
            options={daysToShow || [day]}
            readonly={!daysToShow}
          />
        </View>
        <View style={styles.quantity}>
          <InputFormik
            name='available'
            placeholder='0'
            value={tractor.available}
            onChange={onChangeValue}
            keyboardType='numeric'
            testID={`${day?.name}TractorQuantityInput`}
            readonly
            editable={Boolean(day)}
          />
        </View>
        <View style={styles.equipmentType}>
          <EquipmentsSelectInput
            name='equipmentType'
            selected={tractor.equipmentType}
            onChange={onChangeValue}
            readonly={Boolean(!day)}
          />
        </View>
      </View>
      <View style={styles.checkbox}>
        <CheckBox
          onPress={() => onChangeValue('teams', !tractor.teams)}
          checked={Boolean(tractor.teams)}
          color={day ? 'BUNKER' : 'SLATE_GRAY'}
          disabled={Boolean(!day)}
        />
        <Txt
          color={day ? 'BUNKER' : 'SLATE_GRAY'}
          text='Team'
          identity='body2'
          style={styles.teamsLabel}
        />
      </View>
    </View>
  )
}

TractorForm.propTypes = {
  recurringTractor: PropTypes.object,
  day: PropTypes.object,
  setCurrentDay: PropTypes.func,
  daysToShow: PropTypes.array,
  onSave: PropTypes.func
}

TractorForm.defaultProps = {
  recurringTractor: {},
  day: null,
  setCurrentDay: () => {},
  daysToShow: null,
  onSave: () => {}
}

export default TractorForm
